<template>
  <vh-radio-group v-model="val" @change="change">
    <slot></slot>
  </vh-radio-group>
</template>

<script>
  export default {
    name: 'radioGroup',
    data() {
      return {
        val: ''
      };
    },
    watch: {
      value() {
        this.val = this.value;
      }
    },
    props: {
      value: {
        type: [String, Number],
        default: ''
      }
    },
    methods: {
      change(val) {
        this.$emit('update:value', val);
      }
    }
  };
</script>
